import React, { Component } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Button } from 'semantic-ui-react'
import { connectForm, ModalForm, Group, Form, Field, Submit, InfoGroup, Info } from '~/form'
import { editTask, deleteTask } from '../actions'
import TaskForm, { TaskFormValidations } from './form'
import moment from 'moment'
import { fetchTaskTypes } from '~/taskType/actions'

class TaskEdit extends Component {
  static formSubmit(dispatch, formId, values, changed, meta, { isDelete = false } = {}) {
    if (isDelete) return dispatch(deleteTask(formId, values.get('id')))

    dispatch(editTask(formId, values.get('id'), values.toJS()))
  }

  static formValidation = TaskFormValidations

  componentWillMount = () => {
    let { formInit, task } = this.props
    formInit(task)
  }

  componentDidMount = () => {
    let { typesLoading, fetchTaskTypes } = this.props
    if (typesLoading) fetchTaskTypes()
  }

  render() {
    let { formUpdate, formSubmit, formState, formLoading, onClose, task, types, typesLoading } = this.props

    let actions = (
      <Button
        size="tiny"
        color="green"
        content="Tallenna"
        onClick={e => e.preventDefault() & formSubmit()}
        icon="save"
      />
    )

    return (
      <ModalForm id="task-edit" onSubmit={formSubmit} formState={formState} actions={actions} onClose={onClose}>
        <TaskForm {...this.props} title="Lisää tehtävä" hasDelete />
      </ModalForm>
    )
  }
}

function mapStateToProps(state) {
  return {
    types: state.taskTypes,
    typesLoading: state.taskTypesLoading,
    user_id: state.authUser.id,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchTaskTypes: () => dispatch(fetchTaskTypes()),
  }
}

export default connectForm('task-edit', TaskEdit, mapStateToProps, mapDispatchToProps)
